angular.module("exploitation", ["services", "ui.sortable"]);
